export const C_PROPERTY_INFORMATION_VISITS = {
  REQUEST_KEYS: {
    name: "Llaves",
    label: "Llaves",
    value: "keys",
    id: 0
  },
  KEYS_IN_THE_BUILDING: {
    name: "Llaves en el edificio",
    label: "Llaves en el edificio",
    value: "keys_in_the_building",
    id: 2
  },
  APPOINTMENT: {
    name: "Cita",
    label: "Cita",
    value: "appointment",
    id: 1
  },
  WITH_SCHEDULE: {
    name: "Con horario",
    label: "Con horario",
    value: "with_schedule",
    id: 3
  }
};

export const O_PROPERTY_INFORMATION_VISITS = {
  [C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS.name]:
    C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS,
  [C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING.name]:
    C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING,
  [C_PROPERTY_INFORMATION_VISITS.APPOINTMENT.name]:
    C_PROPERTY_INFORMATION_VISITS.APPOINTMENT,
  [C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE.name]:
    C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE,
  [C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS.label]:
    C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS,
  [C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING.label]:
    C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING,
  [C_PROPERTY_INFORMATION_VISITS.APPOINTMENT.label]:
    C_PROPERTY_INFORMATION_VISITS.APPOINTMENT,
  [C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE.label]:
    C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE,
  [C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS.value]:
    C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS,
  [C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING.value]:
    C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING,
  [C_PROPERTY_INFORMATION_VISITS.APPOINTMENT.value]:
    C_PROPERTY_INFORMATION_VISITS.APPOINTMENT,
  [C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE.value]:
    C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE,
  [C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS.id]:
    C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS,
  [C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING.id]:
    C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING,
  [C_PROPERTY_INFORMATION_VISITS.APPOINTMENT.id]:
    C_PROPERTY_INFORMATION_VISITS.APPOINTMENT,
  [C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE.id]:
    C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE
};

export const A_PROPERTY_INFORMATION_VISITS = [
  C_PROPERTY_INFORMATION_VISITS.REQUEST_KEYS,
  C_PROPERTY_INFORMATION_VISITS.KEYS_IN_THE_BUILDING,
  C_PROPERTY_INFORMATION_VISITS.APPOINTMENT,
  C_PROPERTY_INFORMATION_VISITS.WITH_SCHEDULE
];

export type T_PROPERTIES_TYPE_FOR_SLUG =
  keyof typeof C_PROPERTY_INFORMATION_VISITS;
export type T_PROPERTIES_TYPE_OBJECT = {
  name: string;
  label: string;
  value: string;
  id: number;
};
